import React, {useState} from 'react';
import {Button, Modal} from 'react-bootstrap';
import {FormattedMessage, useIntl} from 'react-intl';
import {useDispatch} from 'react-redux';
import classNames from 'classnames';
import * as actions from '../../_redux/receiptsActions';
import can from '../../../_common/components/Permissions/can';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';

const PopupSendToCreation = ({cellContent}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const disabled = !(can('full', 'receipts') && cellContent.cancaled !== 1) || !cellContent.isActual;
  const buttonClassName = classNames(`btn btn-icon btn-light btn-sm custom-action-button`, {[`cursor-default custom-disabled-button`]: disabled});
  const handleCancelReceipt = ({receiptTypeID, receiptNum, receiptID}) => () => {
    dispatch(actions.cancelReceipt({receiptTypeID, receiptNum, receiptID}));
    handleCloseModal();
  };
  const tooltip = intl.formatMessage({
    id: 'receipts-tooltip-cancelReceipt',
    defaultMessage: 'Cancel receipt',
  });

  return (
    <>
      <div className="font-size-sm d-flex align-items-center justify-content-center">
        <Button
          variant="outline-primary"
          className={buttonClassName}
          title={tooltip}
          onClick={() => {handleShowModal();}}
          disabled={disabled}
        >
          <img
            src={toAbsoluteUrl('/media/svg/Error-circle_brandColor.svg')}
            alt="Cancel"
          />
        </Button>
      </div>
      <Modal
        show={show}
        onHide={handleCloseModal}
      >
        <Modal.Body>
          <h3 className="card-title font-weight-bold text-dark text-center">
            <FormattedMessage
              id="receipts-popup-message"
              defaultMessage="Send all marked invoices to the work?"
            />
          </h3>
          <div className="d-flex justify-content-center">
            <Button
              className="btn-secondary btn-sm col-3 mx-3 "
              onClick={handleCloseModal}
            >
              <FormattedMessage
                id="receipts-popup-no"
                defaultMessage="Cancel"
              />
            </Button>
            <Button
              className="btn-sm col-3 mx-3 custom-send-button"
              onClick={handleCancelReceipt({
                receiptTypeID: cellContent.type,
                receiptNum: cellContent.num,
                receiptID: cellContent._id,
              })}
            >
              <FormattedMessage
                id="receipts-popup-yes"
                defaultMessage="Send"
              />
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PopupSendToCreation;
